import {
  useMutation,
  type UseMutationOptions,
  useQueryClient
} from "@tanstack/react-query";
import { useSearch } from "@tanstack/react-router";

import type { CreateVoucherRequestDto } from "../../dtos/create-voucher-request-dto";
import type { CreateVoucherResponseDto } from "../../dtos/create-voucher-response-dto";
import { VoucherQueryKeys } from "../../generators/voucher-query-keys";
import { VoucherService } from "../../services/voucher-service";

type UsePostCreateVoucherMutationParams = {
  options?: UseMutationOptions<
    CreateVoucherResponseDto,
    unknown,
    CreateVoucherRequestDto
  >;
};

export const usePostCreateVoucherMutation = ({
  options
}: UsePostCreateVoucherMutationParams = {}) => {
  const queryClient = useQueryClient();
  const { q, page, sort } = useSearch({ from: "/vouchers/" });

  return useMutation({
    mutationFn: async (payload) => {
      return await VoucherService.createVoucher({ payload });
    },
    onSuccess: async (...args) => {
      const currentPageKey = VoucherQueryKeys.getVoucherList({
        limit: 10,
        page,
        q,
        sort
      }).queryKey;

      await queryClient.invalidateQueries({ queryKey: currentPageKey });

      options?.onSuccess?.(...args);
    },
    ...options
  });
};
